
import _ from 'lodash';
import queryString from 'query-string';

export const SEARCH_ITEM_KEYS = [
  'field', 'role', 'skill', 'country', 'city', 'company', 'employment', 'benefit',
  'rate', 'companySize', 'companyType', 'language', 'homeoffice', 'remoteWork',
  'suitableFor', 'text'
];
export const KNOWN_PARAMS = ['page', 'sort'];
export const SEARCH_PATHNAME_KEYS = ['field', 'role', 'skill', 'country', 'city', 'suitableFor'];
export const SEARCH_QUERY_KEYS = SEARCH_ITEM_KEYS.filter(item => !SEARCH_PATHNAME_KEYS.includes(item));
export const SEARCH_PATHNAME_REGEXP = new RegExp(`/(${SEARCH_PATHNAME_KEYS.join('|')})/([^/?]+)`, 'g');
export const MODES = ['u', 'd'];
export const RATE_TYPES = ['rate', 'minRate', 'maxRate'];

export const isOldUrlBySearch = search => Object.entries(queryString.parse(search))
  .some(entry => SEARCH_PATHNAME_KEYS.includes(entry[0]));

export const formatItemSuffix = (item) => {
  const level = ~~item.levelId > 0 ? ~~item.levelId : 0;
  const required = !item.not && item.required ? '!' : '';
  const mode = level > 0 && MODES.includes(item.mode) ? item.mode : '';

  if (level || required || mode) {
    return `:${mode}${level}${required}`;
  }

  return '';
};

export const formatItemToQuery = (item) => {
  if (RATE_TYPES.includes(item.type)) {
    item.slug = parseInt(item.slug, 10) || 0;
  }

  return `${item.not ? '-' : ''}${item.slug || encodeURIComponent(item.title)}${formatItemSuffix(item)}`.trim();
};

export const getUrl = (searchItems = [], searchParams = [], resetPage = true) => {
  const itemGroups = _.groupBy(searchItems, 'type');
  const pathnameGroups = SEARCH_PATHNAME_KEYS.map(key => itemGroups[key]).filter(Boolean);
  const pathname = pathnameGroups.map(groupItems =>
    `/${groupItems[0].type}/${groupItems.map(item => formatItemToQuery(item)).join('+')}`).join('');

  const queryGroups = SEARCH_QUERY_KEYS.map(key => itemGroups[key]).filter(Boolean);
  const query = queryGroups.map(queryItems =>
    queryItems.map(item => `${queryItems[0].type}=${formatItemToQuery(item)}`).join('&'))
    .concat(
      searchParams
        .filter(({ key }) => key === 'page' ? !resetPage : true)
        .map(({ key, value }) => `${key}=${value}`)
        .join('&')
    ).join('&');

  return `${pathname || '/'}${query ? `?${query}` : ''}`;
};

export const getPathname = (searchItems = []) => {
  const itemGroups = _.groupBy(searchItems, 'type');
  const pathnameGroups = SEARCH_PATHNAME_KEYS.map(key => itemGroups[key]).filter(Boolean);
  const pathname = pathnameGroups.map(groupItems =>
    `/${groupItems[0].type}/${groupItems.map(item => formatItemToQuery(item)).join('+')}`).join('');

  return pathname || '/';
};

export const parseQueryItem = (item) => {
  const splitted = item.split(':');
  const slug = splitted[0];
  const levelPart = splitted[1] || '';
  const mode = MODES.includes(levelPart[0]) ? levelPart[0] : undefined;
  const level = levelPart.replace(/[^0-9!]+/, '');
  return {
    slug: slug.toString().replace(/^[!-]?/, ''),
    levelId: ~~level.replace('!', ''),
    required: level[level.length - 1] === '!',
    not: slug[0] === '-',
    mode,
  };
};

export const parseQueryItems = (key, queryItems) =>
  (Array.isArray(queryItems) ? queryItems : [queryItems])
    .filter(item => item.trim().length > 0)
    .map((item) => {
      const parsed = parseQueryItem(item);
      parsed.type = key;
      return parsed;
    });

export const getNewUrlFromSearch = (search) => {
  let parsedItems = [];
  const parsedParams = [];

  Object.entries(queryString.parse(search)).forEach((entry) => {
    if (SEARCH_ITEM_KEYS.includes(entry[0])) {
      parsedItems = parsedItems.concat(parseQueryItems(entry[0], entry[1]));
    } else if (KNOWN_PARAMS.includes(entry[0])) {
      parsedParams.push({ key: entry[0], value: entry[1] });
    }
  });

  return getUrl(parsedItems, parsedParams, false);
};
